import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useLocation, useNavigate } from "react-router-dom";
import { msalConfig } from "../config/msalConfig";
import {
  InteractionType,
  RedirectRequest,
} from "@azure/msal-browser";
import { USER_AUTH_TYPE } from "../enums/user-auth-type.enum";
import { Alert, Button } from "react-bootstrap";
import Dashboard from "./Dashboard";
import LoadingPlaceholder from "../components/LoadingPlaceholder";
import Welcome from "../components/Welcome";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAppSelector } from "../store";
import { selectUserOwnerError } from "../store/user-owner/user-owner.selector";
import { createMsalInstance } from "../utils/create-msal-instance";

export default function Registration() {
  const location = useLocation();
  const { inProgress, instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [isValidatingToken, setIsValidatingToken] = useState(false);
  const navigate = useNavigate();
  const ownerError = useAppSelector(selectUserOwnerError) as string | undefined;
  const [storedError, setStoredError] = useState<string | null>(null);
  const authenticate = async () => {
    const query = new URLSearchParams(location.search);
    const token = query.get("token") as string;
    try {
      const loginRequest: RedirectRequest = {
        authority: `${process.env.REACT_APP_MSAL_AUTHORITY}/${USER_AUTH_TYPE.COMARCH_CUSTOMER}`,
        scopes: msalConfig.auth.scopes,
        redirectStartPage: `${process.env.REACT_APP_BASE_URL}/registration`,
      };
      localStorage.setItem("registrationToken", token);
      msalConfig.auth.redirectUri =
        process.env.REACT_APP_MSAL_REGISTRATION_REDIRECT_URI || "";
      msalConfig.auth.authority = `${process.env.REACT_APP_MSAL_AUTHORITY}/${USER_AUTH_TYPE.COMARCH_CUSTOMER}`;
      const msalInstance = await createMsalInstance();
      const res = await msalInstance.loginRedirect(loginRequest);
    } catch (error) {
      localStorage.removeItem("registrationToken");
    }
  };

  useEffect(() => {
    if (ownerError) {
      localStorage.setItem("ownerError", ownerError);
      instance.logoutRedirect({
        authority: `${process.env.REACT_APP_MSAL_AUTHORITY}/${USER_AUTH_TYPE.COMARCH_CUSTOMER}`,
        postLogoutRedirectUri: `${process.env.REACT_APP_BASE_URL}/registration`,
      });
    }
  }, [instance, ownerError]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const token = query.get("token");

    const validateToken = async () => {
      setIsValidatingToken(true);
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_INVITE_API_URL}/Rewards/token/validate`,
          {
            invitationKey: token,
          }
        );
      } catch (err) {
        console.log(err, "err");
        navigate("/");
      } finally {
        setIsValidatingToken(false);
      }
    };

    if (token) {
      validateToken();
    }
  }, [location, navigate]);

  const getDisplayErrorMessage = (message: string) => {
    if (message === "No enrollment found with invitation key of null") {
      return (
        <>
          There was a problem processing your request. Please click the link from your email and login using the email you were invited with.
        </>
      );
    }
    return message;
  };

  useEffect(() => {
    if (localStorage.getItem("ownerError")) {
      setStoredError(localStorage.getItem("ownerError"));
      localStorage.removeItem("ownerError");
    }
  }, []);

  return (
    <>
      {inProgress === "handleRedirect" || isValidatingToken ? (
        <LoadingPlaceholder />
      ) : (
        <>
          {!isAuthenticated ? (
            <>
              {location.search.includes("token") || storedError ? (
                <div className="flex justify-center">
                  <div className="max-w-[450px] bg-white rounded-sm p-4 shadow-sm flex flex-col gap-1 mt-4">
                    {storedError && (
                      <Alert className="text-center mx-auto" variant="danger">
                        {getDisplayErrorMessage (storedError)}
                      </Alert>
                    )}
                    {!storedError ? (
                      <>
                        <h3 className="font-semibold text-2xl">Authentication</h3>
                        <p className="my-4">
                          Before we continue we must first authenticate you to
                          access our Portals. If you have a previous login with us
                          you will be prompted to enter your existing password. If
                          you do not and this is the first time, we will walk you
                          through registration.
                        </p>
                        <Button
                          onClick={authenticate}
                          variant="primary"
                          type="button"
                        >
                          Start
                        </Button>
                      </>
                    ) : (
                      <p className="my-4">
                        You will need close this window and click the link in the email to restart the process.
                      </p>
                    )}
                  </div>
                </div>
              ) : (
                <div></div>
              )}
            </>
          ) : (
            <>
              {localStorage.getItem ('registrationToken') ||
              location.search.includes ('token') ? (
                <Dashboard/>
              ) : (
                <Welcome/>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
